import "./branchForm.css";
import AddBranchForm from './AddBranchForm'
import BranchesList from './BranchesList'

export default function BranchForm({website}) {

    return (
        <div>
            <AddBranchForm website={website}/>
            {website?.settings?.branches?.length > 0 && <BranchesList website={website}/>}
        </div>
    )
}
